import { ConditionalRenderer } from "components";
import styles from "./styles.module.scss";

export const FormLabel = ({ Icon, required, label, className }) => {
  const isWeightIcon = label === "Weight";
  return (
    <div
      className={`${styles.label} ${className} ${
        isWeightIcon ? "" : styles.iconColor
      }`}
    >
      <ConditionalRenderer condition={Icon}>
        <Icon height={18} width={18} />
      </ConditionalRenderer>
      <div>
        {label}
        <ConditionalRenderer condition={required}>
          <span style={{ color: "red" }}>*</span>
        </ConditionalRenderer>
      </div>
    </div>
  );
};
